interface Props {
  color?: string
  width?: number
  height?: number
}

export const MenuIcon = ({ color = '#6F6F6F', width = 21, height = 19 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 0C19.433 0 21 1.567 21 3.5V15.5C21 17.433 19.433 19 17.5 19H3.5C1.567 19 4.83192e-08 17.433 0 15.5V3.5C1.9328e-07 1.567 1.567 6.44256e-08 3.5 0H17.5ZM8 18H17.5C18.8807 18 20 16.8807 20 15.5V3.5C20 2.11929 18.8807 1 17.5 1H8V18ZM3.5 1C2.11929 1 1 2.11929 1 3.5V15.5C1 16.8807 2.11929 18 3.5 18H7V1H3.5Z"
        fill={color}
      />
    </svg>
  )
}
